import { FieldSkeleton } from './components/field-skeleton';

export const SelectTypeSkeleton = () => (
  <div className='flex flex-col gap-4 animate-pulse'>
    <FieldSkeleton />
    <FieldSkeleton />
  </div>
);
